/** OAuth `state` marking a reconnect of an existing grant rather than a first connect. */
export const RECONNECT_STATE = "reconnect";

/**
 * Sends the browser to Google's OAuth consent screen for Calendar access.
 * @param {string} [state] - In-app path the callback should return to, or RECONNECT_STATE.
 * @returns {void}
 */
export const startGoogleConnectOauth = (state) => {
  const clientId = process.env.REACT_APP_OAUTH2_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_OAUTH2_REDIRECT_URI;
  const scope = encodeURIComponent(
    "https://www.googleapis.com/auth/calendar openid email"
  );
  const responseType = "code";
  const accessType = "offline"; // Necessary to receive a refresh token
  const prompt = "consent"; // Ensure consent screen is always shown to get refresh token

  const authUrl =
    `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&access_type=${accessType}&prompt=${prompt}` +
    (state ? `&state=${encodeURIComponent(state)}` : "");

  window.location.href = authUrl;
};
